import React from 'react';
import NoData from '../../../icons/exclamation.svg';
import styles from './EmptyShipmentEvents.scss';

const primaryLabel = 'No tracking information';
const secondaryLabel = 'There is no tracking information available at this time.';

function EmptyShipmentEvents() {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <NoData />
      </div>
      <div className={styles.content}>
        <div className={styles.primaryText}>{primaryLabel}</div>
        <div className={styles.secondaryText}>{secondaryLabel}</div>
      </div>
    </div>
  );
}

export default EmptyShipmentEvents;
